import { Button } from '@readcloud/component-library/components/Base/Button';
import {
  Label,
  TextArea,
} from '@readcloud/component-library/components/Base/Form';

import { Formik } from 'formik';
import React from 'react';

class FormComponent extends React.PureComponent<
  JSX.IntrinsicElements['form'] & { innerRef?: React.Ref<HTMLFormElement> }
> {
  public override render() {
    const { innerRef, ...props } = this.props;
    return <form ref={innerRef} {...props} />;
  }
}

interface BookmarkFormType {
  text: string;
  pageNumber: string;
  pageLabel: string;
}
export const BookmarkForm = ({
  initialValues,
  onSuccess,
  onCancel,
  style,
}: {
  initialValues: BookmarkFormType;
  onSuccess: (values: BookmarkFormType) => void;
  onCancel: () => void;
  style?: React.CSSProperties;
}) => (
  <Formik onSubmit={onSuccess} initialValues={initialValues}>
    {({
      values,
      isSubmitting,
      errors,
      touched,
      handleChange,
      handleSubmit,
      handleBlur,
    }) => (
      <form className="rc-flex rc-flex-col rc-w-full rc-h-full">
        <div className="rc-w-full rc-flex-shrink-0">
          <Label htmlFor="text">Note</Label>
          <TextArea
            className="rc-w-full"
            name="text"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.text}
          />
          {touched.text && !!errors.text && (
            <small className="rc-text-red-500">{errors.text}</small>
          )}
          <div className="rc-py-2" />
        </div>
        <div className="rc-flex rc-flex-1" />
        <div className="rc-flex rc-w-full rc-justify-end">
          <Button variant="light" onClick={onCancel}>
            Cancel
          </Button>
          <div className="rc-px-1" />
          <Button
            variant="primary"
            disabled={isSubmitting}
            onClick={(e) => onSuccess(values)}
          >
            Save
          </Button>
        </div>
      </form>
    )}
  </Formik>
);
